document.addEventListener("DOMContentLoaded", function () {
    // Detect language (Shopify.locale preferred)
    const lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || "en";
    const isSpanish = lang.startsWith("es");

    // Template button id
    const templateButtonId = document.getElementById("template-btn-id").value
    
    // Locate the Add to Cart button
    const addToCartBtn = document.getElementById(templateButtonId);
    if (!addToCartBtn) return;

    // Locate the parent form
    const form = addToCartBtn.closest("form");
    if (!form) return;

    // English → Spanish mapping
    const flavorTranslations = {
        "Mixed Berry": "Frutos Rojos",
        "Lemon Lime": "Lima Limón",
        // "Watermelon Hibiscus": "Sandía Hibisco",
        "Coconut Lime": "Coco Limón",
        "Passion Fruit": "Maracuyá",
        "Tangerine": "Mandarina"
    };

    // Canonical English keys
    const flavorListEN = Object.keys(flavorTranslations);

    // Check URL to determine number of flavor selects
    const currentUrl = window.location.href;
    const urlPath = window.location.pathname;
    const isBundleProduct = urlPath.includes('holiday-hydration-creatine-bundle') || 
                            urlPath.includes('paquete-festivo-de-hidratacion-creatina');
    const numberOfSelects = isBundleProduct ? 3 : 4;

    // Wrapper for selects
    const wrapper = document.createElement("div");
    wrapper.id = "flavor-selects-wrapper";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.gap = "10px";
    wrapper.style.margin = "15px 0";

    function createFlavorSelect(index) {
        const label = document.createElement("label");
        label.textContent = isSpanish ? ("Sabor " + index) : ("Flavor " + index);
        label.style.fontSize = "14px";
        label.style.fontWeight = "600";

        const select = document.createElement("select");
        select.id = "flavorSelect" + index;
        // Property name stays constant (you will see "Flavor 1" in the order)
        select.name = "properties[Flavor " + index + "]";
        select.style.padding = "6px";
        select.style.marginTop = "4px";

        // Placeholder
        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = isSpanish ? "Selecciona un sabor" : "Select a flavor";
        placeholder.disabled = true;
        placeholder.selected = true;
        select.appendChild(placeholder);

        // Add flavor options
        flavorListEN.forEach(flavorEN => {
            const option = document.createElement("option");

            // ❗ IMPORTANT:
            // If store is Spanish -> save Spanish text
            // If store is English -> save English text
            const spanishLabel = flavorTranslations[flavorEN];

            option.value = isSpanish ? spanishLabel : flavorEN;

            // What the customer sees
            option.textContent = isSpanish ? spanishLabel : flavorEN;

            select.appendChild(option);
        });

        // Validate on change
        select.addEventListener("change", validateSelects);

        const fieldBox = document.createElement("div");
        fieldBox.style.display = "flex";
        fieldBox.style.flexDirection = "column";
        fieldBox.appendChild(label);
        fieldBox.appendChild(select);

        return fieldBox;
    }

    // Generate flavor selects (3 for bundle products, 4 for others)
    for (let i = 1; i <= numberOfSelects; i++) {
        wrapper.appendChild(createFlavorSelect(i));
    }

    // Insert before Add to Cart
    addToCartBtn.parentNode.insertBefore(wrapper, addToCartBtn);

    // Enable/disable button
    function setButtonEnabled(enabled) {
        addToCartBtn.disabled = !enabled;
    }

    function validateSelects() {
        const selects = wrapper.querySelectorAll("select");
        const allSelected = Array.from(selects).every(sel => sel.value);
        setButtonEnabled(allSelected);
    }

    // Initial state
    setButtonEnabled(false);
});
